import uberLogo from '../../../assets/partners/aliados/uber.svg';
import uberEatsLogo from '../../../assets/partners/aliados/uber-eats.svg';
import didiLogo from '../../../assets/partners/aliados/didi.svg';
import didiFoodLogo from '../../../assets/partners/aliados/didi-food.svg';
import rappiLogo from '../../../assets/partners/aliados/rappi.svg';
import mercadoLibreLogo from '../../../assets/partners/aliados/mercado-libre.svg';
import zubaleLogo from '../../../assets/partners/aliados/zubale.png';
import lalamoveLogo from '../../../assets/partners/aliados/lalamove.webp';
import airbnbLogo from '../../../assets/partners/aliados/airbnb.svg';
import mercadoEnviosLogo from '../../../assets/partners/aliados/mercado-envios.svg';
import walmartLogo from '../../../assets/partners/aliados/walmart.svg';
import koviLogo from '../../../assets/partners/aliados/kovi.svg';
import boosmapLogo from '../../../assets/partners/aliados/boosmap.webp';
import workanaLogo from '../../../assets/partners/aliados/workana.webp';
import deelLogo from '../../../assets/partners/aliados/deel.svg';
import doctoraliaLogo from '../../../assets/partners/aliados/doctoralia.webp';
import terapifyLogo from '../../../assets/partners/aliados/terapify.svg';
import amazonLogo from '../../../assets/partners/aliados/amazon.webp';
import bancoppelLogo from '../../../assets/partners/aliados/bancoppel.webp';
import heruLogo from '../../../assets/img/svg/heru-logo-v3.svg';
import {
	decodeHtmlEntities,
	toProperName,
} from '../../../shared/utils/approvalFlow.util';

interface PlatformDisplay {
	pattern: string;
	display: string;
	logo?: string;
}

const PLATFORM_DISPLAY: PlatformDisplay[] = [
	{ pattern: 'rebuilding technology', display: 'DiDi Food', logo: didiFoodLogo },
	{ pattern: 'uber portier', display: 'Uber Eats', logo: uberEatsLogo },
	{ pattern: 'uber b', display: 'Uber', logo: uberLogo },
	{ pattern: 'didi', display: 'DiDi', logo: didiLogo },
	{ pattern: 'rappi', display: 'Rappi', logo: rappiLogo },
	{ pattern: 'deremate', display: 'Mercado Libre', logo: mercadoLibreLogo },
	{ pattern: 'uber moto', display: 'Uber moto', logo: uberLogo },
	{ pattern: 'lalamove', display: 'Lalamove', logo: lalamoveLogo },
	{ pattern: 'section b', display: 'Zubale', logo: zubaleLogo },
	{ pattern: 'mu team sa de cv', display: 'Mensajeros Urbanos' },
	{ pattern: 'booking.com', display: 'Booking' },
	{ pattern: 'getjusto', display: 'Justo' },
	{ pattern: 'meli operaciones', display: 'Mercado Libre', logo: mercadoLibreLogo },
	{ pattern: 'section h servicios', display: 'Zubale', logo: zubaleLogo },
	{ pattern: 'mercado envios', display: 'Mercado Envíos', logo: mercadoEnviosLogo },
	{ pattern: 'airbnb', display: 'Airbnb', logo: airbnbLogo },
	{ pattern: 'wal mart', display: 'Walmart', logo: walmartLogo },
	{ pattern: 'walmart', display: 'Walmart', logo: walmartLogo },
	{ pattern: 'kovi', display: 'Kovi', logo: koviLogo },
	{ pattern: 'boosmap', display: 'Boosmap', logo: boosmapLogo },
	{ pattern: 'pomonte servicios', display: 'Boosmap', logo: boosmapLogo },
	{ pattern: 'workana', display: 'Workana', logo: workanaLogo },
	{ pattern: 'deel ', display: 'Deel', logo: deelLogo },
	{ pattern: 'doctoralia', display: 'Doctoralia', logo: doctoraliaLogo },
	{ pattern: 'terapify', display: 'Terapify', logo: terapifyLogo },
	{ pattern: 'kuarto', display: 'heru', logo: heruLogo },
	{ pattern: 'servicios comerciales amazon', display: 'Amazon MX', logo: amazonLogo },
	{ pattern: 'bancoppel', display: 'BanCoppel', logo: bancoppelLogo },
];

export const cleanCounterpartyName = (rawName: string) => decodeHtmlEntities(rawName).replace(/["']/g, '').trim();

export const platformDisplayOf = (rawName: string) => {
	const lower = cleanCounterpartyName(rawName).toLowerCase();
	return PLATFORM_DISPLAY.find(({ pattern }) => lower.includes(pattern));
};

export const resolveCounterpartyDisplay = (
	rawName: string,
): { name: string; logo?: string } => {
	const match = platformDisplayOf(rawName);
	return match
		? { name: match.display, logo: match.logo }
		: { name: toProperName(cleanCounterpartyName(rawName)) };
};
